/** Organization metadata entry: `{ colors: string[] }` (hex strings, e.g. `#FFFFFF`). */
export const ORG_METADATA_GALLERY_BG_REMOVAL_COLORS_KEY =
  'GALLERY_BG_REMOVAL_COLORS'

export const ORG_METADATA_GALLERY_BG_REMOVAL_KEYS = [
  ORG_METADATA_GALLERY_BG_REMOVAL_COLORS_KEY,
] as const
